import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import da from './da.json';
import sv from './sv.json';
import nb from './nb.json';
import de from './de.json';
import { detectMarket, MARKET_GERMANY } from '../utils/market';

const germanyDefaultDetector = {
  name: 'germanyDefault',
  lookup() {
    if (typeof window === 'undefined') return undefined;

    const storedLanguage = window.localStorage.getItem('i18nextLng');
    if (storedLanguage) return undefined;

    if (detectMarket() === MARKET_GERMANY) {
      return 'de';
    }

    return undefined;
  },
};

const denmarkDefaultDetector = {
  name: 'denmarkDefault',
  lookup() {
    if (typeof window === 'undefined') return undefined;

    const storedLanguage = window.localStorage.getItem('i18nextLng');
    if (storedLanguage) return undefined;

    const browserLanguages = [navigator.language, ...(navigator.languages || [])]
      .filter(Boolean)
      .map((value) => value.toLowerCase());

    const usesDenmarkLocale = browserLanguages.some((value) => /(^|-)dk$/.test(value));
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone?.toLowerCase() || '';
    const usesDenmarkTimezone = timezone === 'europe/copenhagen';

    if (usesDenmarkLocale || usesDenmarkTimezone) {
      return 'da';
    }

    return undefined;
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(germanyDefaultDetector);
languageDetector.addDetector(denmarkDefaultDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      da: { translation: da },
      sv: { translation: sv },
      nb: { translation: nb },
      de: { translation: de },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'germanyDefault', 'denmarkDefault', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => {
        // Map "no" (Norwegian generic) to "nb" (Bokmål)
        if (lng === 'no' || lng.startsWith('no-') || lng.startsWith('nb-')) return 'nb';
        if (lng.startsWith('da-')) return 'da';
        if (lng.startsWith('sv-')) return 'sv';
        if (lng.startsWith('de-')) return 'de';
        if (lng.startsWith('en-')) return 'en';
        return lng;
      },
    },
  });

export default i18n;
